import React from "react";

function View(props, { locals }) {
  return (
    <div id="error-wrapper">
      <div className="inset">
        <h1 className="alt">Access Denied</h1>
        <p>
          You’re not authorized to view this page.
          <br />
          Try one of these instead:
        </p>
        <div className="Quick-Links">
          <a href="/dashboard/">
            <svg className="icon" viewBox="0 0 42 42">
              <path d="M11.71,9.8l1.43,1.43a12.35,12.35,0,0,1,15.3,0L29.87,9.8a14.38,14.38,0,0,0-18.15,0Z" />
              <path d="M9.59,11.92a14.4,14.4,0,0,0,0,18.16L11,28.66a12.37,12.37,0,0,1,0-15.31Z" />
              <path d="M32,11.92l-1.43,1.43a12.37,12.37,0,0,1,0,15.31L32,30.08a14.4,14.4,0,0,0,0-18.16Z" />
              <path d="M27,13.15l-3.92,4A4.32,4.32,0,1,0,24.73,19a4.24,4.24,0,0,0-.24-.39l3.93-4Zm-3.94,8.49a2.34,2.34,0,1,1-.12-1.79A2.32,2.32,0,0,1,23.05,21.64Z" />
              <path d="M20.79.42A20.58,20.58,0,1,0,41.38,21,20.61,20.61,0,0,0,20.79.42Zm0,39.17A18.58,18.58,0,1,1,39.38,21,18.6,18.6,0,0,1,20.79,39.58Z" />
            </svg>
            Dashboard
          </a>

          <a href="/dashboard/">
            <svg className="icon" viewBox="0 0 42 42">
              <rect x="25.67" y="20" width="11.27" height="2" />
              <rect x="20.72" y="9.83" width="2" height="22.33" />
              <rect x="15.92" y="11.88" width="2" height="18.25" />
              <rect x="10.99" y="15.39" width="2" height="11.22" />
              <path d="M21,.42A20.58,20.58,0,1,0,41.58,21,20.61,20.61,0,0,0,21,.42Zm0,39.17A18.58,18.58,0,1,1,39.58,21,18.6,18.6,0,0,1,21,39.58Z" />
            </svg>
            Program Builder
          </a>

          <a href="/dashboard/">
            <svg className="icon" viewBox="0 0 42 42">
              <path d="M27.86,35.45a16,16,0,0,0,2-1.12V18.23h-2Z" />
              <path d="M20.07,37c.31,0,.62,0,.93,0s.71,0,1.07-.05V12.77h-2Z" />
              <path d="M12.14,34.33a16,16,0,0,0,2,1.12v-11h-2Z" />
              <path d="M21,.42A20.58,20.58,0,1,0,41.58,21,20.61,20.61,0,0,0,21,.42Zm0,39.17A18.58,18.58,0,1,1,39.58,21,18.6,18.6,0,0,1,21,39.58Z" />
            </svg>
            Metrics
          </a>

          <a href="/dashboard/">
            <svg className="icon" viewBox="0 0 42 42">
              <path d="M21,.42A20.58,20.58,0,1,0,41.58,21,20.61,20.61,0,0,0,21,.42Zm0,39.17A18.58,18.58,0,1,1,39.58,21,18.6,18.6,0,0,1,21,39.58Z" />
              <path d="M31.52,9l-5,10.35a8.26,8.26,0,0,0-3.26-1.79l-1.33-2.73,4.34-8.91a15.84,15.84,0,0,0-2-.56l-3.5,7.18L17.33,5.42A15.85,15.85,0,0,0,15.39,6L20.84,17.2a8.24,8.24,0,0,0-5.64,2.36l-5-10.32a16.15,16.15,0,0,0-1.48,1.53l5.14,10.55a8.27,8.27,0,1,0,14.07-.37L33,10.45A16.15,16.15,0,0,0,31.52,9ZM21,31.75a6.28,6.28,0,1,1,6.28-6.28A6.28,6.28,0,0,1,21,31.75Z" />
            </svg>
            Competition Tracker
          </a>
        </div>
      </div>
    </div>
  );
}

const AccessDenied = (app) => {
  app.get("/401", ({ res }) => (res.body = <View />));
};

export default AccessDenied;
